import BaseDomainService from "./baseDomainServices";
import { ErrorMessage, SuccessMessage } from "../../utils/Messages";
import { getValidationRuleList } from "../../utils/validation/generateValidationRule";
import { DataFormat } from "../../utils/DateFormat";
import { getAuthProps } from "../../utils/AuthenticationLibrary";

const regulationFormDetail = {
    requestName: "",
    regulationId: "",
    regulationFile: "",
    regulationFileName: "",
    createdBy: 1,
};

export default class RegulationRequestDomainService extends BaseDomainService {

    // API Endpoints
    addRegulationRequest = this.apiService.regulationService.addRegulationRequest;
    getRegulationRequestList = this.apiService.regulationService.getAllRegulationRequest;
    getRegulationRequestById = this.apiService.regulationService.getRegulationRequestById;

    // Grid columns for regulation requests
    regulationRequestGridColmns = [
        { name: "requestName", title: "Request Name" },
        { name: "statusName", title: "Status Name" },
        { name: "createdDate", title: "CreatedDate" },
        { name: "regulationRequestId", title: "Actions" },
    ];

    // State data
    regulationDataItem;

    formFieldsSearch = [
        {
            inputType: "text",
            tittle: "",
            placeholder: "Search ...",
            fieldName: "searchText",
            mode: 1,
            className: 'col-md-4 mb-0'
        },
    ];

    regulationFormFields = [
        {
            inputType: "text",
            tittle: "RequestName",
            placeholder: "RequestName",
            fieldName: "requestName",
            className: "col-md-6",
            validation: [{ type: "require" }]
        },
        {
            inputType: "select",
            tittle: "Regulation Name",
            placeholder: "Select Regulation Name",
            fieldName: "regulationId",
            options: [],
            optionFieldName: "regulationId",
            className: 'col-md-6',
            validation: [{ type: "require" }]
        },
        {
            inputType: "file",
            tittle: "RegulationFile",
            placeholder: "RegulationFile",
            fieldName: "regulationFile",
            className: 'col-md-6',
            validation: [{ type: "require" }]
        }
    ];

    constructor() {
        super();
        this.onPaginationUpdate = this.onGetRegulationRequestList.bind(this);
        this.regulationActionKey = "regulationRequestId";
        const authUser = getAuthProps();
        this.regulationDataItem = { ...regulationFormDetail, createdBy: authUser ? authUser.adminUserId : null };
    }

    onAddRegulationRequest = (request) => {
        this.apiService.onAPICall("addRegulationRequest", this.addRegulationRequest, request, this.onAPIResponse, this.onUpdateState);
    };

    onGetRegulationRequestList = (request) => {
        this.apiService.onAPICall("getRegulationRequestList", this.getRegulationRequestList, request, this.onAPIResponse, this.onUpdateState);
    };

    onGetRegulationRequestById = (request) => {
        this.apiService.onAPICall("getRegulationRequestById", this.getRegulationRequestById, request, this.onAPIResponse, this.onUpdateState);
    };

    onRegulationInitService() {
        let valRule = getValidationRuleList(this.regulationFormFields);
        this.validationRules = valRule;

        this.onUpdateState({
            validationRules: valRule,
            resetValidationRule: this.resetValidationRule,
        });
    }

    onRedirectoRegulationRequestList = () => {
        this.onRedirect('/ManageRegulationRequest');
    };

    onAPIResponse = (key, isSuccess, responseData) => {
        if (!isSuccess) {
            this.onUpdateState({ setIsLoad: false });
            return;
        }

        switch (key) {
            case "addRegulationRequest":
                this.apiService.serviceManager.swalServices.Success(
                    SuccessMessage.Insert_Success.replace("{0}", "New Regulation Request")
                );
                this.onRedirectoRegulationRequestList();
                this.onUpdateState({ setIsLoad: false });
                break;

            case "getRegulationRequestList":
                if (responseData != null) {
                    let listData = responseData.itemList;
                    listData.forEach(function (i) {
                        i.createdDate = DataFormat(i.createdDate);
                    });
                    this.onUpdateState({
                        getList: responseData.itemList,
                        TotalCount: responseData.totalCount,
                    });
                }
                this.onUpdateState({ setIsLoad: false });
                break;

            case "getRegulationRequestById":
                if (responseData != null) {
                    responseData.createdDate = DataFormat(responseData.createdDate);
                    this.onUpdateState({ detailData: responseData });
                }
                this.onUpdateState({ setIsLoad: false });
                break;

            default:
                break;
        }
    };
}